import React from "react";

// Компонент для відображення чекбоксу типу is_full
const ToggleFilterCheckbox = React.memo(({ id, label, checked, onChange }) => {
  return (
    <div className="toggle-filter-checkbox">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="checkbox"
        className="focus-checkbox"
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
});

export default ToggleFilterCheckbox;
